// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"qempo_Tooltip_tooltip-2YTBLrF","tooltipIcon":"qempo_Tooltip_tooltipIcon-21_tLKt","tooltipBox":"qempo_Tooltip_tooltipBox-3Pfh3ju","place-right":"qempo_Tooltip_place-right-3Qzx5Jw"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Tooltip/Tooltip.scss
// module id = 1353
// module chunks = 0